import { GeckoEntry, RolodexEntryType } from 'types'

export interface SearchResultNavigation {
  to: string
  params?: Record<string, string>
  search?: Record<string, string>
}

export function getSearchResultUrl(
  entry: GeckoEntry,
  siteID: string
): SearchResultNavigation | null {
  switch (entry.type) {
    case RolodexEntryType.UNIT:
      return {
        to: '/assets/$siteID/$unitID',
        params: { siteID, unitID: entry.id },
        search: { view: 'details' },
      }
    // TODO: We need to add system to url params
    case RolodexEntryType.SYSTEM:
      return {
        to: '/system-lens/$siteID',
        params: { siteID },
      }
    case RolodexEntryType.JOB:
      return {
        to: '/job/$siteID',
        params: { siteID },
        search: { jobId: entry.id },
      }
    case RolodexEntryType.ASSET_MODEL:
      return {
        to: '/assets/$siteID/$unitID',
        params: { siteID, unitID: entry.tags.unit! },
        search: { view: 'components' },
      }
    case RolodexEntryType.INSPECTION:
      return {
        to: '/assets/$siteID/$unitID',
        params: { siteID, unitID: entry.tags.unit! },
        search: { view: 'inspections' },
      }
    case RolodexEntryType.VALUE_STORY:
      return {
        to: '/value-stories/$siteID/$valueStoryID',
        params: { siteID, valueStoryID: entry.id },
      }
    default:
      return null
  }
}
